import { render, staticRenderFns } from "./AsideIcon.vue?vue&type=template&id=0a08d20a&"
import script from "./AsideIcon.vue?vue&type=script&lang=js&"
export * from "./AsideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports